import { geodropFeatureImage } from './features'
import { StatCard, StatCardProps } from '../Stats'

import { useUserInfo } from '../../../User'

const CollectedCard: React.FC<React.PropsWithChildren<StatCardProps>> = (props) => {
  const { userInfo, loading } = useUserInfo()

  return (
    <StatCard
      title="Geodrops"
      subtitle="All time"
      action="View More"
      actionTo="/geodrops"
      actionToOptions={{
        state: {
          filter: 'dropsCollected',
        },
      }}
      value={loading ? undefined : userInfo?.xyoPickedUp ?? 0}
      image={geodropFeatureImage}
      description="COIN"
      {...props}
    />
  )
}

export default CollectedCard
